import { api } from "./httpClient";

export const staffService = {
  list(tenantId) {
    return api(`/v1/staff?tenantId=${encodeURIComponent(tenantId || "")}`).then((res) => res?.content || []);
  },
  save(payload) {
    if (payload?.uuid) {
      return api(`/v1/staff/${encodeURIComponent(payload.uuid)}`, {
        method: "PUT",
        body: JSON.stringify(payload),
      });
    }
    return api("/v1/staff", {
      method: "POST",
      body: JSON.stringify(payload),
    });
  },
  remove(uuid) {
    return api(`/v1/staff/${uuid}`, { method: "DELETE" });
  },
  restore(uuid) {
    return api(`/v1/staff/${uuid}/restore`, { method: "POST" });
  },
};
